import { Area } from './types';

export const getMaskImage = (areas: Area[], container: HTMLElement) => {
  const rect = container.getBoundingClientRect();
  const width = rect.width;
  const height = rect.height;

  const parts: string[] = [];
  parts.push(
    `url("data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 ${width} ${height}' width='${width}' height='${height}'>`,
  );

  for (const area of areas) {
    parts.push(
      `<rect x='${area.x - rect.x}' y='${area.y - rect.y}' width='${
        area.width
      }' height='${area.height}' />`,
    );
  }

  parts.push(`</svg>"), linear-gradient(#000, #000)`);

  return parts.join('').replace(/</g, '%3C').replace(/>/g, '%3E');
};
